    
<template>
    <a-spin :spinning="chartloading">
        <div class="dashBox">
            <div class="dashTitle">
                <span> {{ chartType == 'resourcetopID' ? 'Top10资源耗时':'Top10接口耗时'}} </span>
                <a-button type="link" style="float:right" @click="handleDetail">详情</a-button>
            </div>
            <a-empty v-if="timeList.length == 0" description="暂无数据" style="margin-top:80px;" />

            <div :id="chartType" style="width: 100%;padding-top:10px;"></div>
        </div>
    </a-spin>
</template>

<script>

export default {
    data() {
        return {
            chartloading:false,
            resurlList:[],
            timeList:[],
            chartSys:undefined,
            tempTimeRange:''
        }
    },

    methods: {
        handleDetail(){
            let timeRange = this.tempTimeRange;
            if(this.chartType == 'resourcetopID'){
                this.$router.push({
                    path: '/monitorweb/logs',
                    query:{
                        logType:'resource',
                        timeRange:timeRange,
                    }
                })
            }
            else{
                this.$router.push({
                    path: '/monitorweb/logs',
                    query:{
                        logType:'api',
                        timeRange:timeRange,
                    }
                })
            }
        },
        loadData(selectedEnv,hostName,timeRange){
            let that = this;
            that.tempTimeRange = timeRange;
            timeRange = timeRange.split('~');
            let starttime = (new Date(timeRange[0]).getTime())/1000;
            let endtime = (new Date(timeRange[1]).getTime())/1000;
            let queryStr = ''
            if(that.chartType == 'resourcetopID'){
                queryStr="* | select round(approx_percentile(res_duration,0.9),1) as TP90,res_url from log where project_name='"+hostName+"' and log_type = 'resource' group by res_url order by TP90 desc"
            }
            else{
                queryStr = "* | select round(approx_percentile(res_duration,0.9),1) as TP90,res_url from log where project_name='"+hostName+"' and log_type = 'api' group by res_url order by TP90 desc";

            }
            that.chartloading = true;
            let params = {
                projectname:'fp-zl-device',
                logstorename:selectedEnv,
                starttime:starttime,
                endtime:endtime,
                sql:queryStr,
                pageSize:10,
                offset:0,
                reverse:false,
                paged:false,
                timeout:15000,
                urlparams:false
            };
            that.$store.dispatch({
                type: "logservice/querylog",
                params:params
            }).then((res)=>{
                if(res.status == 200 && res.data.success == '1'){

                    let result = res.data.data;
                    let array = result.list;
                    that.resurlList = [];
                    that.timeList = [];
                    for (let index = 0; index < array.length; index++) {
                        const element = array[index];
                        let tempUrl = element.res_url;
                        // if(that.chartType != 'resourcetopID'){
                        //     tempUrl = element.res_url.split('/')[3] ? element.res_url.split('/')[3] : element.res_url;
                        // }
                        that.resurlList.push(tempUrl);
                        let tempTime = parseFloat((element.TP90 / 1000).toFixed(1));
                        that.timeList.push(tempTime)
                    }
                    if(that.resurlList.length > 0){
                        that.analystData();
                    }
                    
                }
                that.chartloading = false;
            }).catch(() => {
                that.chartloading = false;
            });
        },
        //按日期统计数据
        analystData(){
            let that = this;
            if(that.chartSys){
                that.chartSys.clear();
            }
            document.getElementById(that.chartType).style.height = "360px";
            that.chartSys = that.$echarts.init(document.getElementById(that.chartType));
            
            let option = that.getDatailOption();
            // 窗口大小自适应方案
            that.chartSys.setOption(option);
            that.chartSys.off('click');
            that.chartSys.on('click', function () {
            });
            
        },
        getDatailOption(){
            let that = this;
            let option = {
          
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                        type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                    }
                },

                color:that.G.getChartColors(),
                xAxis: [
                    {
                        type: 'category',
                        axisLabel: {  
                            interval:0,      //坐标轴刻度标签的显示间隔(在类目轴中有效) 0:显示所有  1：隔一个显示一个 :3：隔三个显示一个...
                            rotate:-45,    //标签倾斜的角度，显示不全时可以通过旋转防止标签重叠（-90到90）
                        },
                    
                        data: that.resurlList
                    }
                ],
                yAxis: [
                    {
                        type: 'value',
                        axisLabel:{
                            formatter: '{value} s'
                        }
                    }
                ],
                series: [
                    {
                        name: 'TP90',
                        type: 'bar',
                        data: that.timeList,
                        markPoint: {
                            data: [
                                {type: 'max', name: '最大值'},
                                {type: 'min', name: '最小值'}
                            ]
                        },
                        markLine: {
                            data: [
                                {
                                    silent:false,
                                    lineStyle:{               //警戒线的样式  ，虚实  颜色
                                        type:"solid",
                                        color:"#91cc75",
                                    },
                                    yAxis: that.chartType == 'resourcetopID' ? 5 : 3          
                                }
                            ]
                        }
                    }
                ]
            };
            return option;
        },
        chartResize(){
            let eleArr = [this.chartSys];
            for(let i = 0; i<eleArr.length; i++){
                //此处定时器是为了在页面存在多个图时，resize方法的调用时间微微错开，避免明显的卡顿
                setTimeout(function(){
                    if(eleArr[i]){
                        eleArr[i].resize();
                    }
                }, 200);
            }
        },
    },
    mounted() {
        window.addEventListener("resize", this.chartResize);
    },
    destroyed(){
        window.removeEventListener("resize", this.chartResize);

    },
    props:{
        chartType:String
    }
}
</script>

<style scoped>

    .dashBox{
        min-height: 395px;
        border: 1px solid lightgray;
        padding-bottom: 20px;
        background-color: white;
    }
    .dashTitle{
        width: 100%;
        height: 40px;
        color: #00c1de;
        line-height:38px;
        padding:0 10px;
        border-bottom: 1px solid lightgray;
        cursor: default;
    }
</style>
